// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32ul-","image":"Header_image__2NJwc","name":"Header_name__1BpWq","info":"Header_info__2AVYD","infoRow":"Header_infoRow__2rOft"};